import { parseAsStringEnum, useQueryState } from 'nuqs'
import { type PropsWithChildren } from 'react'

import useShelfDetails from '@components/shelfDetails/useShelfDetails'

import ProductFinderContext, { type ProductFinderContext as ProductFinderContextType } from './Context'

const ALL_SEARCH_STATES = ['initial', 'open', 'closed'] as const

export type SEARCH_STATE = typeof ALL_SEARCH_STATES[number]

function ProductFinderProvider({ children }: PropsWithChildren) {
  const [gtin, setGtin] = useQueryState('gtin')
  const { shelfId, setShelfId } = useShelfDetails()

  const [searchState, setSearchState] = useQueryState(
    'search',
    parseAsStringEnum([...ALL_SEARCH_STATES]).withDefault('initial')
  )

  async function updateGtinAndInferShelfId(gtin?: string) {
    if (!gtin) {
      await setGtin(null)
      return
    }

    await setGtin(gtin)
    return
  }

  async function handleShelfChange(newShelfId: string | undefined) {
    if (!newShelfId) {
      return setShelfId(undefined)
    }

    return setShelfId(newShelfId)
  }

  const value: ProductFinderContextType = {
    searchState,
    setSearchState,
    selectedGTIN: gtin ?? undefined,
    setSelectedGTIN: updateGtinAndInferShelfId,
    selectedShelfId: shelfId,
    setSelectedShelfId: handleShelfChange,
  }

  return (
    <ProductFinderContext.Provider value={value}>
      {children}
    </ProductFinderContext.Provider>
  )
}

export default ProductFinderProvider